import * as Yup from 'yup'

export const fieldValidation = Yup.object({
	fieldLabel: Yup.string().required('Field is required'),
	options: Yup.array(),
})
